import { IVehicleBase, IDriverBase, IPerson, IAddress, IListOption, IDriver, IContactInfo, ICoverageConfig } from "./Domain";

export interface ILienholder {
    name: string,
    address: IAddress | null;
}

export interface ICoverage {
    name: string,
    limit: string,
    premiumAmt: string;
}

export interface IVehicle extends IVehicleBase {
    isLeased: boolean,
    changed: boolean,
    wasSalvaged: boolean | null,
    hasLienholder: boolean,
    coverages: Array<ICoverage>,
    lienholder: ILienholder | null,
    vinVerified: boolean;
}

export interface ICoverages extends ICoverageConfig {
    changed: boolean
}

export interface IAgreement {
    agreeDrivers: boolean,
    //agreeVehicles: boolean,
    agreeOtherDrivers: boolean,
    //agreeSalvage: boolean,
    agreeUMDecline: boolean,
    agreeEmailCorrect: boolean,
    agreePolicyEffDate: boolean
}

export interface IMvrResult extends IBaseResult {
    drivers: Array<IDriver>,
    hasViolationData: boolean,
    hasAdditionalDrivers: boolean,
    additionalDriversWasAdded: boolean,
    isRerated: boolean;
}

export interface IViolation {
    id: number,
    driverId: number,
    incidentDescription : string,
    date: string,
    isAccident : boolean,
    allowedDispute: boolean,
    accDisSet: string | null,
    disputeOptions: Array<IListOption> | null
}

export interface IPolicyDocument {
    name: string,
    downloadUrl: string;
}

export interface IBindResult extends IBaseResult {
    policyNumber  : string,
    documents: Array<IPolicyDocument>;
}

export interface IUpdateVehicleResult extends IBaseResult {
    vehicleChanged: boolean,
    wasSalvaged: boolean,
    isRerated: boolean;
}

export interface IUpdateCoveragesResult extends IBaseResult {
    coveragesChanged: boolean,
    isRerated: boolean;
}

export interface IUpdateApplicantResult extends IBaseResult {

}

export interface IUpdateDriverResult extends IBaseResult {
    birthDtChanged: boolean,
    licenseStateChanged: boolean,
    isRerated: boolean;
}

export interface IUpdateAdditionalDriverResult extends IBaseResult {
    isRerated: boolean
}

export interface IUpdateCreditCardResult {
    errors: Array<string>,
    paymentPlanCode: number;
}

export interface IBindQuoteResult extends IBaseResult {

}

export interface IBaseResult {
    isSuccess: boolean,
    errors: Array<string>;
}

export interface IExternalQuote {
    rtrQuoteId: number, // pc submission_id
    id: number, // lob submission id
    //number: number,
    paymentPlanCode: number,
    effectiveDate: string,
    effectiveDatetimeStamp: string,
    installmentDueDate: string,
    insured: IPerson,
    agreement: IAgreement | null,
    vehicles: Array<IVehicle>,
    drivers: Array<IDriver>,
    mvrResult: IMvrResult,
    reRated: boolean,
    hasMvrViolations: boolean,
    esignatureForms: Array<IESignatureForm>,
    bindResult: IBindResult | null,
    hasAdditionalDrivers: boolean,
    contactInfo: IContactInfo | null,
    coverages: ICoverages | null;
    questions: Array<IQuoteQuestion> | null;
}

export interface IESignatureForm {
    code: string,
    name: string,
    displayOrder: number,
    module: IEsignatureModule,
    processed: boolean
}

export interface IEsignatureModule {
    needToSign: boolean,
    applicantSignature: string,
    wording: string,
    esigStart: string,
    esigEnd: string,
    moduleOptions: Array<IEsignatureModuleOption>
}

export const ESIG_MODULE_OPTION_TYPES = {
    YES_NO: 1,
    PHONE_NUMBER: 2,
    YES_NO_SELECTED: 3
}

export interface IEsignatureModuleOption {
    label: string,
    value: string,
    type: number,
    isValid: boolean | null
}

export interface IQuoteQuestion {
    code: string,
    question: string,
    answer: boolean | null,
    anyAnswer: boolean,
    defaultValue: boolean
}
